<template>
  <div>
    <div class="bg-primary py-2 fixed-top text-white">
      <div class="container-fluid">
        <div class="d-flex justify-content-between align-items-center" style="min-height: 24px">
          <div class="small font-weight-bold">
            Auto Terminal
          </div>
          <div>
            <a class="text-white mr-3" href="javascript:" @click="openModalConfigs(true)">
              <i class="fa fa-cog"></i>
            </a>
            <a v-if="isReadOnly" class="text-white" href="javascript:" @click="confirmLogout()">
              <i class="fa fa-sign-out-alt"></i>
            </a>
            <router-link v-else class="text-white" to="/home">
              <i class="fa fa-sign-out-alt"></i>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="container-terminal">
      <div class="middle">
        <div>
          <div class="mb-3">
            <img src="../../assets/bg-terminal.png">
          </div>
          <h4 class="font-weight-bold">{{msg.titulo}}</h4>
          <div class="mb-2">{{msg.descricao}}</div>
        </div>
      </div>
    </div>

    <modal :opened="modalConfigs">
      <div class="container-fluid">
        <h6 class="text-center font-weight-bold">Configurações</h6>
        <hr>
        <form @submit.prevent="salvarConfigs()">
          <div class="form-group">
            <label class="mb-0">Código do Produto</label>
            <input id="iptProduto" v-model="config.produto" class="form-control" placeholder="Ex: 99" required type="number">
          </div>
          <div class="form-group">
            <label class="mb-0">Finalizar pedido</label>
            <select v-model="config.imprimir" class="form-control">
              <option :value="true">Imprimir</option>
              <option :value="false">Não imprimir</option>
            </select>
          </div>
          <div class="border-top text-center pt-3 mt-4">
            <button class="btn btn-success px-4" type="submit">Salvar</button>
          </div>
        </form>
      </div>
    </modal>

    <div v-if="cupom" id="cupomPeso" class="hide">
      <div class="text-center">
        <b>{{ usuario.nome_fantasia }}</b>
        <div>COMPROVANTE DE AUTOPESAGEM</div>
        <div>{{cupom.data_pesagem}} - #{{cupom.id_cupom}}</div>
        <div>Comanda: {{ cupom.ref_comanda }}</div>
        <div>Atendente: {{usuario.nome}}</div>
      </div>
      <hr>
      <div>
        <div>
          <b class="float-right">{{ produto.nome_produto }}</b>
          Produto:
        </div>
        <div>
          <b class="float-right">{{ cupom.valor | valor }}</b>
          Preço / Kg
        </div>
        <div>
          <b class="float-right">{{ cupom.quantidade.toFixed(3) }} kg</b>
          Peso:
        </div>
        <div>
          <b class="float-right">{{ cupom.valor_total | valor }}</b>
          Valor Total:
        </div>
      </div>
      <hr>
      <div class="text-center small">
        Automatizado por LeCard<br>
        <b>www.lecard.delivery</b>
      </div>
    </div>
  </div>
</template>

<script>
  import Loading from "../../components/gestor/loading";
  import Modal from '../../components/gestor/ModalGestor'
  import createBarcodeListener from "../../services/barcode";

  export default {
    name: 'AutoTerminal',
    components: { Loading, Modal },
    data() {
      return {
        token: localStorage.getItem('key'),
        empresa: localStorage.getItem('token'),
        load: false,
        step: 1,
        timeOutBalanca: null,
        tentativas: 1,
        produto: null,

        listener: null,
        config: { produto: '', imprimir: true },
        modalConfigs: false,

        dados: { comanda: {}, produtos: [] },
        msg: { titulo: '', descricao: '' },

        cupom: null,
        peso: 0
      }
    },

    methods: {
      pesquisarProduto(termo, callback) {
        if (termo) {
          this.produto = null;
          const produto = this.produtos.find(p => p.ref_produto === termo);

          if (produto) {
            this.produto = {
              id_tabela_preco: produto.id_tabela_preco,
              nome_produto: produto.nome_produto,
              valor_custo: produto.valor_custo,
              ref_produto: produto.ref_produto,
              id_medida: produto.id_medida,
              valor: produto.valor,
              valor_total: 0,
              quantidade: 0
            }

            this.id_medida = this.produto.id_medida;

            callback(true);
            return;

          } else {
            this.$swal('nao encontrado');
          }

          callback(false);
        }
      },

      changeInstrucoes() {
        switch (this.step) {
          case 1:
            this.msg.titulo = 'Coloque o prato na balança.';
            this.msg.descricao = 'Depois faça a leitura da comanda no leitor.';
            break;

          case 2:
            this.msg.titulo = 'Aguarde a leitura do peso.';
            this.msg.descricao = 'Coloque o prato na balança.';
            break;

          case 3:
            this.msg.titulo = 'Tudo certo!';
            this.msg.descricao = 'Finalizando o pedido..';
            break;

          case 4:
            this.msg.titulo = 'Obrigado!';
            this.msg.descricao = '';
            break;
        }
      },

      limparPedido() {
        this.step = 1;
        this.tentativas = 1;
        this.changeInstrucoes();
        this.dados = {
          comanda: {},
          produtos: [],
        }

        this.$nextTick(() => window.focus());
      },

      onBarcode(code) {
        if (this.step !== 1) {
          return;
        }

        if (!code) return;

        this.dados.produtos = [];
        this.dados.comanda = {
          ref_comanda: code,
          tipo_comanda: '3'
        }

        this.step = 2;
        this.tentativas = 1;
        this.changeInstrucoes(2);

        setTimeout(() => this.lerPeso(), 3000);
      },

      lerPeso() {
        if (!this.isElectron) {
          this.msg.descricao = "Instale o Gestor LeCard para usar a integração com a balança.";
          setTimeout(() => this.limparPedido(), 10000);
          return;
        }

        this.timeOutBalanca = setTimeout(() => {
          this.tentativas++;
          this.msg.descricao = "Tentativa de leitura: " + this.tentativas;

          if (this.tentativas < 4) {
            this.lerPeso();
            //this.adicionar('0.210');

          } else {
            this.limparPedido();
          }
        }, 10000);

        document.dispatchEvent(new CustomEvent('comandoAcbr', { detail: "BAL.LePeso" }));
      },

      adicionar(peso) {
        const valor_produto = this.produto.valor > 0 ? this.produto.valor : 0;
        const quantidade = parseFloat(peso);

        if (quantidade > 0) {
          this.produto.valor_total = (quantidade * valor_produto).toFixed(2);
          this.dados.produtos.push({
            quantidade,
            id_tabela_preco: this.produto.id_tabela_preco,
            nome_produto: this.produto.nome_produto,
            valor_total: this.produto.valor_total,
            id_medida: this.produto.id_medida,
            produto: {
              valor: this.produto.valor,
              valor_custo: this.produto.valor_custo,
            }
          });

          setTimeout(() => this.finalizar(peso), 3000);
        }
      },

      finalizar(peso) {
        if (!this.dados.produtos.length) {
          return;
        }

        this.dados.origin_pdv = true;
        this.dados.reuse = true;
        this.step = 3;
        this.changeInstrucoes();

        if (this.config.imprimir) {
          this.msg.descricao = 'Imprimindo comprovante..'
        }

        this.$http.post("pdv/pedido/" + this.token, this.dados)
          .then(res => {
            if (res.data && res.data.id_pedido) {
              const id_pedido = res.data.id_pedido;
              this.$socket.emit('comanda_order', { token: this.empresa, content: { id_pedido, tipo_comanda: '3' } });

              if (this.config.imprimir) {
                this.imprimir(res.data.id_pedido);
              }

              setTimeout(() => this.msgObrigado(peso), 3000);

            } else {
              this.lerPeso();
            }

          }, res => {
            console.log(res);
            this.msg.titulo = res.data.msg || 'Erro temporário';
            this.msg.descricao = 'Por favor aguarde';
            this.lerPeso();
          });
      },

      msgObrigado() {
        this.step = 4;
        this.changeInstrucoes();
        setTimeout(() => this.limparPedido(), 9000);
      },

      imprimir(id_cupom) {
        const dados = this.dados.produtos[0];

        this.cupom = {
          id_cupom,
          data_pesagem: new Date().toLocaleString('pt-BR'),
          nome_produto: dados.nome_produto,
          quantidade: dados.quantidade,
          valor_total: dados.valor_total,
          valor: dados.produto.valor,
          ref_comanda: this.dados.comanda.ref_comanda
        }

        this.$nextTick(() => {
          const content = document.getElementById('cupomPeso');
          const cf = this.$store.state.impressora;
          const device = cf.devicePdv || null;
          const dataImpressao = {
            content: content.innerHTML,
            copies: 1,
            isPdv: true,
            status: 1,
            nome_documento: 'Impressão balança',
            device,
            impressora: {
              device,
              zoom: cf.zoom || "9px",
              largura: cf.largura || '100%'
            }
          };

          this.$helpers.imprimir(this, localStorage.getItem('token'), [dataImpressao], cf.mobilePrint);
        });
      },

      acbrReply(e) {
        if (e.detail && e.detail.startsWith('OK:')) {
          const kilo = parseFloat(e.detail.replace('OK:','').trim().replace(',','.'));

          if (!isNaN(kilo) && kilo > 0) {
            this.adicionar(kilo.toFixed(3));

            // limpa o timeout
            clearTimeout(this.timeOutBalanca);
          }

        } else if (e.detail) {
          this.msg.descricao = e.detail;
        }
      },

      openModalConfigs(senha) {
        this.modalConfigs = true;
      },

      fecharModalConfigs() {
        this.modalConfigs = false;
        this.$nextTick(() => window.focus());
      },

      salvarConfigs() {
        if (!this.config.produto) {
          this.openModalConfigs();
          return;
        }

        this.pesquisarProduto(this.config.produto, (res) => {
          if (res) {
            localStorage.setItem('terminalConfigs', JSON.stringify(this.config));
            this.fecharModalConfigs();
            this.limparPedido();

          } else {
            this.$swal('Produto não encontrado.');
            this.openModalConfigs();
          }
        });
      },

      confirmLogout() {
        this.$swal({
          text: "Deseja sair do sistema?",
          buttons: ["Cancelar", "Sim"],
          dangerMode: true
        }).then((result) => {
          if (result) {
            this.logout();
          }
        });
      }
    },

    mounted() {
      window.focus();
      document.addEventListener("acbrReply", this.acbrReply);

      // listener do codigo de barras
      this.listener = createBarcodeListener(this.onBarcode);
      this.listener.start();

      // configs
      this.config = this.$helpers.parseJSONObject(localStorage.getItem('terminalConfigs')) || this.config;
      this.salvarConfigs();
    },

    computed: {
      usuario() {
        return this.$store.state.dataUser
      },

      produtos() {
        return this.$store.state.produtos
      },

      isReadOnly() {
        return this.$store.state.isReadOnly;
      }
    },

    beforeDestroy() {
      this.listener.stop();
      document.removeEventListener("acbrReply", this.acbrReply);
    }
  }
</script>

<style scoped>
  .container-terminal {
    margin-top: 54px;
    padding-bottom: 94px
  }

  .container-terminal .middle {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 75vh;
    text-align: center;
  }

  .container-terminal .middle img {
    width: 144px;
  }
</style>
